import axios, { type AxiosResponse } from 'axios';

type RequestHandlerOptions = {
  throwOnError?: boolean;
  throwOriginalError?: boolean;
};

const handleRequest = async <T = unknown>(
  request: () => Promise<AxiosResponse<T>>,
  options: RequestHandlerOptions = {
    throwOnError: true,
    throwOriginalError: false,
  }
): Promise<AxiosResponse<T>> => {
  try {
    const response = await request();
    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      if (options?.throwOriginalError) {
        throw error.response.data;
      }

      if (options?.throwOnError) {
        throw new Error(error.response.data.message);
      }

      return error.response;
    }

    console.log(error);
    throw error;
  }
};

export { handleRequest, type RequestHandlerOptions };
